var _rect, _ellipse, _path, _path2, _path3, _path4, _ellipse2, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Redis logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 6,
    ry: 6,
    fill: "#D82C20"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 16,
    rx: 12,
    ry: 5,
    fill: "#C6271D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16v10c0 2.8 5.372 5 12 5s12-2.2 12-5V16",
    fill: "#B9221B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.2c4.2-1.6 11.5-1.6 16 0",
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.5c4.2-1.6 11.5-1.6 16 0",
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 26.8c4.2-1.6 11.5-1.6 16 0",
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 14.2,
    rx: 10,
    ry: 3.2,
    fill: "rgba(255,255,255,0.06)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 40,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontWeight: 700,
    fontSize: 7.5,
    fill: "#FFF",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "redis")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedis);
export default __webpack_public_path__ + "static/media/redis.ca83296b89d054ecf0679773b3014fb5.svg";
export { ForwardRef as ReactComponent };